import gql from "graphql-tag";

const ADD_REPLY = gql`
    mutation Reply($name: String!, $commentID: ID, $reply: String!){
        createReply(input: { data: {
        name: $name,
        comment: $commentID,
        reply: $reply
        } }){
        reply{
            id
            name    
            reply
        }
        }
    }
`
export default ADD_REPLY